import {
  ConfigProvider,
  Flex,
  Typography,
} from 'antd'
import React from 'react'

import { formatPercentage } from '@/utils/formatter'

const { Text } = Typography

export type FansReportsChartData = { name: string, count: number, growth?: number, dateStr: string }

export default function FansReportsTooltip({ dateStr, data }: {
  dateStr: string,
  data: FansReportsChartData[]
}) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: 'var(--ant-color-text)',
        },
      }}
    >
      <Flex vertical>
        <Text strong>{dateStr}</Text>
        {data.map((item, idx) => {
          return (
            <Flex key={idx} gap={8}>
              <Text>{item.name}: {item.count}</Text>
              {item.growth !== undefined &&
                <Text type={item.growth > 0 ? 'success' : 'danger'}>
                  {formatPercentage()(item.growth)}
                </Text>
              }
            </Flex>
          )
        })}
      </Flex>
    </ConfigProvider>
  )
}
